import { Component } from '@angular/core';

@Component({
    selector: 'app-health-check',
    templateUrl: './health-check.component.html',
    styleUrl: './health-check.component.scss',
    standalone: false
})
export class HealthCheckComponent {

}
